var map = {
	"./de/about.json": 6351,
	"./de/contact.json": 275,
	"./de/footer.json": 5352,
	"./de/projects.json": 6326,
	"./de/translation.json": 1647,
	"./en/about.json": 1318,
	"./en/contact.json": 4731,
	"./en/footer.json": 3165,
	"./en/projects.json": 1125,
	"./en/translation.json": 6938,
	"./pl/about.json": 6602,
	"./pl/contact.json": 5984,
	"./pl/footer.json": 6140,
	"./pl/projects.json": 1553,
	"./pl/translation.json": 4720
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2914;